/**
 * This type tries to follow the `Flux Standard Action`.
 * We call it Message however instead of Action.
 * https://github.com/redux-utilities/flux-standard-action
 */

export var isData = function isData(a) {
  return a != null && !("error" in a);
};
export var isError = function isError(a) {
  return a != null && "error" in a;
};